import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical, Loader2, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/Shared";

function MpStatus({ s }) {
  if (!s) return <p className="mb-4 text-sm text-slate-400" data-testid="mp-status-loading">Verificando conta Mercado Pago...</p>;
  if (!s.ok) return <p className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-700" data-testid="mp-status-error">{s.error}</p>;
  const warn = s.is_test_account || !s.pix_enabled;
  return (
    <div data-testid="mp-status" className={`mb-4 flex gap-2.5 rounded-lg p-3 text-sm ${warn ? "bg-amber-50 text-amber-900" : "bg-emerald-50 text-emerald-800"}`}>
      {warn ? <AlertTriangle className="h-5 w-5 shrink-0" /> : <CheckCircle2 className="h-5 w-5 shrink-0" />}
      <div>
        <p>Conta conectada: <b data-testid="mp-status-account">{s.nickname} ({s.account_id})</b></p>
        {s.is_test_account && <p data-testid="mp-status-test-warning"><b>Estas são credenciais de uma conta de TESTE.</b> Pagamentos reais serão recusados. Gere o Access Token de produção entrando com sua conta real do Mercado Pago.</p>}
        <p data-testid="mp-status-pix">{s.pix_enabled ? "Pix habilitado no checkout." : "Pix não habilitado: cadastre uma chave Pix nesta conta."}</p>
      </div>
    </div>
  );
}

export default function AdminTestPayment() {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);
  useEffect(() => { api.get("/admin/payments/mercadopago/status").then((r) => setStatus(r.data)).catch((e) => setStatus({ ok: false, error: errMsg(e) })); }, []);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/payments/mercadopago/test"); window.location.assign(data.init_point); }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Panel title="Pagamento de teste (só admin)" sub="Cobra R$ 1,00 via Pix no Mercado Pago para validar a confirmação automática. Não altera nenhum plano." icon={FlaskConical} testid="admin-test-payment-panel">
      <MpStatus s={status} />
      <button data-testid="admin-test-payment-btn" onClick={run} disabled={busy}
        className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[#009ee3] px-5 text-sm font-bold text-white transition-colors hover:bg-[#0089c7] disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}Pagar R$ 1,00 de teste
      </button>
    </Panel>
  );
}
